module.exports = __webpack_public_path__ + "img/process-5.49e8f34c.png";